import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { MtUser } from "server/models"
import { EDIT } from "const"
import { hasAccess } from "client/utils"
import {
    PRM_ACCOUNT,
    StoreType,
    addModal,
} from "client/store"
import {
    UserIcon,
    TableColumn,
    TablePopover,
    TablePopoverData,
} from "client/components"

import AssignedUserGroups from "client/pages/mt/userGroups/assigned"

const Columns = (accountId: number) => {
    const groupList = useSelector((state: StoreType) => state.group.groupList)
    const userGroupList = useSelector((state: StoreType) => state.userGroup.userGroupList)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const editAccess = hasAccess(PRM_ACCOUNT, EDIT)

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
        },
        {
            field: "firstName",
            header: lang.name,
            sortable: true,
            cellMinWidth: "250px",
            formatter: (user: MtUser) => <UserIcon user={user} size="sm" />,
        },
    ]

    if (accountId !== 1) { // Super Admin account has no groups
        columns.push({
            field: "groups",
            header: lang.groups,
            cellMinWidth: "200px",
            formatter: (user: MtUser) => {
                if (!groupList || !userGroupList) return null

                const groupIds = userGroupList[user.id] || []
                const dataList: TablePopoverData[] = []
                groupIds.forEach((groupId) => {
                    const group = groupList[groupId]
                    if (group) {
                        dataList.push({
                            id: `${user.id}_${group.id}`,
                            title: group.name,
                        })
                    }
                })

                return (
                    <TablePopover
                        id={`userGroups${user.id}`}
                        dataList={dataList}
                        placement="left"
                        title={lang.groups}
                        editAccess={editAccess}
                        onClick={() => dispatch(addModal({
                            key: "assignedUserGroups",
                            content: <AssignedUserGroups accountId={accountId} userId={user.id} />,
                        }))}
                    />
                )
            },
        })
    }

    columns.push({
        field: "status",
        header: lang.status,
        centerAlign: true,
        sortable: true,
        editAccess: () => userData.accountId === 1, // only Super Admin can deactivate users
    })

    if (editAccess) {
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        })
    }

    return columns
}
export default Columns
